import React from 'react';

export const Footer = ({ onTermsOpen }) => {
  return (
    <footer>
      <div className="fbrand">Nismay <em>Studios</em></div>
      <div className="fright">
        <a onClick={onTermsOpen}>Terms & Conditions</a>
        <div className="fcopy">© 2026 Nismay Studios · Gulbarga</div>
      </div>
    </footer>
  );
};